export const USER_INFO_ENDPOINT = '/support/userinfo';
export const SUPPORT_ENVIRONMENT_ENDPOINT = '/support/support-env';
//# sourceMappingURL=constants.js.map